export const GET_SENSORS = 'GET_SENSORS';
export const SENSORS_UPDATED = 'SENSORS_UPDATED';